module.exports = __webpack_public_path__ + "static/media/ubuntu.05114c5c.svg";